// Helper function to clean query parameters from a url.
const clean = (href) => {
	// Create url object.
	let url;

    try {
      url = new URL(href);
    } catch (_) {
      return href;
    }

	// Array of query parameters to remove.
    const paramBlacklist = ['_ga'];

    paramBlacklist.forEach(function(param) {
      url.searchParams.delete(param);
    })

    return url.href; 
};

export default clean;
